import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { TranslocoService } from '@jsverse/transloco';
import { ColumnDefinitionDto } from 'src/app/data-transfer/entities/user-profile-dto';

export interface ColumnOrganizerDialogData {
  columnCatalog: ColumnDefinitionDto[];
  visibleColumns: string[];
  entityLabelKey: string;
}

@Component({
  selector: 'app-column-organizer-dialog',
  templateUrl: './column-organizer-dialog.component.html',
  styleUrls: ['./column-organizer-dialog.component.scss'],
})
export class ColumnOrganizerDialogComponent {
  visibleColumns: ColumnDefinitionDto[];
  availableColumns: ColumnDefinitionDto[];
  searchTerm = '';

  constructor(public dialogRef: MatDialogRef<ColumnOrganizerDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: ColumnOrganizerDialogData, private translateService: TranslocoService) {
    this.visibleColumns = data.visibleColumns.map(key => data.columnCatalog.find(c => c.key === key)).filter((c): c is ColumnDefinitionDto => c != null);
    this.availableColumns = data.columnCatalog.filter(c => !data.visibleColumns.includes(c.key));
  }

  get dialogTitle(): string {
    return this.translateService.translate('columnOrganizer.title', { entity: this.translateService.translate(this.data.entityLabelKey) });
  }

  get filteredAvailableColumns(): ColumnDefinitionDto[] {
    if (!this.searchTerm) {
      return this.availableColumns;
    }
    const term = this.searchTerm.toLowerCase();
    return this.availableColumns.filter(c => this.translateService.translate(c.labelKey).toLowerCase().includes(term));
  }

  drop(event: CdkDragDrop<ColumnDefinitionDto[]>): void {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
    }
  }

  hideColumn(column: ColumnDefinitionDto): void {
    this.visibleColumns = this.visibleColumns.filter(c => c.key !== column.key);
    this.availableColumns = [...this.availableColumns, column];
  }

  showColumn(column: ColumnDefinitionDto): void {
    this.availableColumns = this.availableColumns.filter(c => c.key !== column.key);
    this.visibleColumns = [...this.visibleColumns, column];
  }

  save(): void {
    this.dialogRef.close(this.visibleColumns.map(c => c.key));
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
